// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","primaryBackgroundColor":"#140046","uiBlack":"#000000","defaultTiming":"ease-out","dashboardAnimation":"1s ease-out"};